import React, { Component } from 'react';
// import { Document, Page, pdfjs } from 'react-pdf';

// import { Document, Page } from 'react-pdf/dist/esm/entry.webpack'

// import { Document, Page } from 'react-pdf/dist/esm/entry.webpack5';
// import 'react-pdf/dist/esm/Page/TextLayer.css';
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
// import axios from 'axios';

export default class Documentationread extends Component {
	state = { numPages: null, pageNumber: 1 };

	onDocumentLoadSuccess = ({ numPages }) => {
		this.setState({ numPages });
	};

	goToPrevPage = () =>{

		window.scrollTo({top: window.innerHeight, left: 0, behavior: 'smooth'});
		this.setState((state) => ({ pageNumber: state.pageNumber - 1 }));
	}
	goToNextPage = () =>{
		window.scrollTo({top: window.innerHeight, left: 0, behavior: 'smooth'});
		this.setState((state) => ({ pageNumber: state.pageNumber + 1 }));
	}

	render() {
		const { pageNumber, numPages } = this.state;
		
		return (
			<div>
			
				<div>
					{/* <iframe src={`${this.props?.filePdf}#view=fitH`}  width="100%" height={ (window.innerHeight * 0.9) +"px"}></iframe> */}
					<embed src={`${this.props?.filePdf}#view=fitH`} type="application/pdf"  width="100%" height={ (window.innerHeight * 0.9) +"px"}></embed>
                    {/* {
						this.props?.filePdf && (
							<Document
								file={this.props?.filePdf}
								onLoadSuccess={this.onDocumentLoadSuccess}
								onLoadError={ console.error}
								className={"border border-1 border-primary"}
							>
								<Page pageNumber={pageNumber} width={ window.innerWidth > 664 ? (window.innerWidth * 60 ) / 100 : (window.innerWidth * 80 ) / 100} className={"border border-1 border-danger"} />
							</Document>
						)
					} */}
					
				</div>
                <div className='mb-2'>
					{/* <p className='font-monospace'>
						Page <span className=''>{pageNumber}</span> sur {numPages}
					</p>
					
					<nav>
						<button type='button' className='btn btn-sm btn-primary mx-1 font-monospace' onClick={this.goToPrevPage}>Préc</button>
						<button  type='button' className='btn btn-sm btn-primary font-monospace' onClick={this.goToNextPage}>Suiv</button>
					</nav> */}
				</div>

			</div>
		);
	}
}